export default __webpack_public_path__ + "62175d6cd18e6691eea1d0c79a87e892.png";